'use strict';

/**
 *
 * @name: nownessApp.players
 *
 */

/**
 *
 * Directives
 *
 */

import NnBlackFrameDirective from './nn-black-frame/nn-black-frame.directive';

import NnDropdownCreditsDirective from './nn-dropdown-credits/nn-dropdown-credits.directive';
import NnDropdownCommentsDirective from './nn-dropdown-comments/nn-dropdown-comments.directive';
import NnDropdownPlaylistDirective from './nn-dropdown-playlist/nn-dropdown-playlist.directive';
import nnDropdownRatingsDirective from './nn-dropdown-ratings/nn-dropdown-ratings.directive';

import NnImageSliderDirective from './nn-image-slider/nn-image-slider.directive';

import NnBrightcoveNewDirective from './nn-player-brightcove/nn-player-brightcove-new.directive';
import NnCinematiqueDirective from './nn-player-cinematique/nn-player-cinematique.directive';
import NnVimeoDirective from './nn-player-vimeo/nn-player-vimeo.directive';
import NnYoutubeDirective from './nn-player-youtube/nn-player-youtube.directive';

import NnShareStickyFooterDirective from './nn-share-sticky-footer/nn-share-sticky-footer.directive';
import NnSocialIconsDirective from './nn-social-icons/nn-social-icons.directive';
import NnSoloPlayerDirective from './nn-solo-player/nn-solo-player.directive';

/**
 *
 * Factories
 *
 */

import BrightcoveNewHelperFactory from './nn-player-brightcove/nn-player-brightcove-new-helper.factory';
import PlayersAnalyticsFactory from './nn-players-analytics.factory';

const PlayersModule = angular
  .module('nownessApp.players', [])
  .directive('blackFrame', NnBlackFrameDirective)
  .directive('brightcoveNew', NnBrightcoveNewDirective)
  .directive('cinematique', NnCinematiqueDirective)
  .directive('nnDropdownComments', NnDropdownCommentsDirective)
  .directive('nnDropdownCredits', NnDropdownCreditsDirective)
  .directive('nnDropdownPlaylist', NnDropdownPlaylistDirective)
  .directive('nnDropdownRatings', nnDropdownRatingsDirective)
  .directive('nnImageSlider', NnImageSliderDirective)
  .directive('shareStickyFooter', NnShareStickyFooterDirective)
  .directive('socialIcons', NnSocialIconsDirective)
  .directive('nnSoloPlayer', NnSoloPlayerDirective)
  .directive('vimeo', NnVimeoDirective)
  .directive('youtube', NnYoutubeDirective)
  .factory('brightcoveNewHelperServ', BrightcoveNewHelperFactory)
  .factory('playersAnalytics', PlayersAnalyticsFactory);

export default PlayersModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-players.module.js